import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class ApplyCouponApiReducer extends Reducer {

  static setCouponData(state, action) {
    return {
      ...state,
      couponApiSummary: {
        data: action.payload,
        isFetching: action.payload.isFetching,
        isSuccess: action.payload.isSuccess,
      },
    };
  }
}

const applyCouponApiActionHandlers = {
  [ActionConstants.SET_COUPON_DATA]: ApplyCouponApiReducer.setCouponData,
};

const initialState = {
  couponApiSummary: {
    data: {},
    isFetching: true,
        isSuccess: false,
  },
};

export const couponApiSummary = createReducer(
  initialState,
  applyCouponApiActionHandlers
);
